import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-text">
        Coding Problem :{" "}
        <a href="https://www.geektrust.com/challenge/admin-ui">
          geektrust admin-ui
        </a>
      </p>
    </div>
  );
};

export default Footer;
